import { ReactNode } from 'react';

import { Checkbox, Stack, Typography } from '@cast/design-system';

type Props = {
  title: string;
  checked?: boolean;
  disabled?: boolean;
  onChange?: () => void;
  children?: ReactNode;
};

export const RebalanceOptionLayout = ({
  title,
  checked,
  disabled,
  onChange,
  children,
}: Props) => (
  <Stack gap={10}>
    <Stack direction="row" alignItems="center" gap={8}>
      <Checkbox
        disableRipple
        tabIndex={-1}
        size="small"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <Typography variant="P12M">{title}</Typography>
    </Stack>

    {children}
  </Stack>
);
